import React from 'react';
import Hero from '../../components/User/Home/Hero';
import PiAbout from '../../components/User/Home/PiAbout';
import MinemoServices from '../../components/User/Home/Minemoservices';
import MinemoCTA from '../../components/User/Home/Minemocta ';
import OurPlans from '../../components/User/Home/OurPlans';
import Testimonial from '../../components/User/Home/Testimonial';
import OurBlog from '../../components/User/Home/OurBlog';
import OurServices from '../../components/User/Home/OurServices';
import MinemoVideoBanner from '../../components/User/Home/Minemovideobanner';
import MinemoContact from '../../components/User/Home/Minemocontact';

const Home = () => (
    <div id='home'>
        <Hero/>
        <PiAbout/>
        <OurServices/>
        <MinemoServices/>
        <MinemoCTA/>
        <OurPlans/>
        <Testimonial/>
        <MinemoContact/>
        <MinemoVideoBanner/>
        <OurBlog/>

    </div>
);

export default Home;
